import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalPublishedRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/published",
  component: lazyRouteComponent(() => import("./published.page.js"), "PortalPublishedPage"),
});
